export const METRIC_DEFS = [
  { key: "mrr", label: "MRR", type: "currency", hint: "Monthly Recurring Revenue" },
  { key: "arr", label: "ARR", type: "currency", hint: "Annual Recurring Revenue" },
  { key: "cash_balance", label: "Cash Balance", type: "currency", hint: "Cash in bank" },
  { key: "net_burn", label: "Net Burn", type: "currency", hint: "Monthly net cash burn", invert: true },
  { key: "runway_months", label: "Runway", type: "months", hint: "Months of runway left" },
  { key: "headcount", label: "Headcount", type: "number", hint: "Total team size" },
  { key: "customers", label: "Customers", type: "number", hint: "Paying customers" },
  { key: "mom_growth_pct", label: "MoM Growth", type: "percent", hint: "Month-over-month growth" },
  { key: "churn_pct", label: "Churn", type: "percent", hint: "Customer/revenue churn", invert: true },
];

export const METRIC_KEYS = METRIC_DEFS.map((m) => m.key);

export function metricLabel(key) {
  const d = METRIC_DEFS.find((m) => m.key === key);
  return d ? d.label : key;
}

// Compute % delta between latest and previous numeric values
export function computeDelta(latest, prev) {
  if (latest === null || latest === undefined || prev === null || prev === undefined) return null;
  if (isNaN(Number(latest)) || isNaN(Number(prev)) || Number(prev) === 0) return null;
  return ((Number(latest) - Number(prev)) / Math.abs(Number(prev))) * 100;
}
